import { render, staticRenderFns } from "./FindingComposer.vue?vue&type=template&id=32e363dd&scoped=true"
import script from "./FindingComposer.vue?vue&type=script&lang=js"
export * from "./FindingComposer.vue?vue&type=script&lang=js"
import style0 from "./FindingComposer.vue?vue&type=style&index=0&id=32e363dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e363dd",
  null
  
)

export default component.exports